import React, { ReactNode } from 'react';
import BoxButton from '../../BoxButton';
import CloseIcon from '@/legacy/assets/img/svg/close.svg';
import Button from '../../Button';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

export type InfoModalProps = {
	isOpen: boolean;
	onClose: () => void;
	titleIcon?: ReactNode;
	date?: string;
	imageSrc: string;
	title: string;
	description: string;
	subtext?: {
		icon?: ReactNode;
		text: string;
	};
	buttonAction?: {
		icon?: ReactNode;
		text: string;
		onClick: () => void;
	};
	linkAction?: {
		text: string;
		href: string;
	};
};

const InfoModal = ({
	isOpen,
	onClose,
	imageSrc,
	titleIcon,
	date,
	title,
	description,
	buttonAction,
	subtext,
	linkAction,
}: InfoModalProps) => {
	const { t } = useTranslation();
	if (!isOpen) return null;

	const handleOutsideClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e.target === e.currentTarget) {
			onClose();
		}
	};

	return (
		<div
			className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'
			onClick={handleOutsideClick}
		>
			<div className='bg-light rounded-xl border border-card-border  w-full max-w-md relative'>
				<div
					className='relative w-full h-48 bg-cover bg-center rounded-t-xl'
					style={{ backgroundImage: `url(${imageSrc})` }}
				>
					<BoxButton onClick={onClose}>
						<img
							src={CloseIcon}
							alt='Close modal'
							className='w-4 h-4'
						/>
					</BoxButton>
				</div>

				<div className='p-10'>
					<header className='flex items-center justify-between mb-4'>
						<div className='flex items-center justify-center gap-2'>
							{titleIcon && titleIcon}
							<h2 className='text-xl font-semibold'>{t(title)}</h2>
						</div>
						{date && <span className='text-sm'>{t(date)}</span>}
					</header>
					<main className='mb-10'>
						<p>{description}</p>
						{subtext && (
							<div className='flex items-center gap-2 mt-4'>
								{subtext.icon}
								<span className='text-secondary'>{t(subtext.text)}</span>
							</div>
						)}
					</main>

					<footer className='flex flex-col sm:flex-row justify-start gap-4 mt-4'>
						{buttonAction && (
							<Button
								onClick={buttonAction.onClick}
								text={t(buttonAction.text)}
								iconLeft={buttonAction.icon}
								style='highlighted'
							/>
						)}
						{linkAction && (
							<Link
								to={linkAction.href}
								className='text-cuaternary hover:text-primary first-letter-uppercase inline-block'
							>
								{t(linkAction.text)}
							</Link>
						)}
					</footer>
				</div>
			</div>
		</div>
	);
};

export default InfoModal;
